'use client';

import { memo } from 'react';
import { SimpleGrid, Box } from '@chakra-ui/react';
import { NestedProject } from '@habity/types';
import { ProjectListCard } from '~/components/projects/list/ProjectListCard';
import { NoResults } from './components/NoResults';

interface ProjectsGridProps {
  projects: NestedProject[];
  projectsLoading?: boolean;
  hasMore?: boolean;
}

const ProjectsGridComponent = ({ projects }: ProjectsGridProps) => {
  if (!projects || projects.length === 0) {
    return <NoResults tab="projects" />;
  }

  return (
    <SimpleGrid
      columns={{ mobile: 1, tablet: 2, desktop: 3 }}
      rowGap="10"
      columnGap="5"
    >
      {projects.map((project) => (
        <Box key={project.id || `skeleton-${Math.random()}`}>
          <ProjectListCard project={project} />
        </Box>
      ))}
    </SimpleGrid>
  );
};

export const ProjectsGrid = memo(ProjectsGridComponent);
